// engine
import { ArContainer, ArSprite, appDispatcher } from "@aceroll/core";

// configs
import { payLinesConfig } from "../configs/pay-lines-config";

/*
{
	'000': Sprite
}
*/

export class WinLines extends ArContainer {
	#winLines = {};

	constructor() {
		super('win-lines');
		this.#generateLines(payLinesConfig);

		//DEBUG
		// window.wl = this;
	}
	#generateLines(config) {
		for (let i = 0; i < config.length; i++) {
			const payline = config[i];
			const winLineId = '' + payline.positions[0] + payline.positions[1] + payline.positions[2];
			const sprite = ArSprite.from(payline.image, 'WinLine ' + winLineId);
			sprite.anchor.set(0.5);
			sprite.zIndex = 150;
			sprite.position.set(payline.x, payline.y);
			this.#winLines[winLineId] = sprite;
		}

	}
	play(id) {
		const { slotMachine } = appDispatcher.state.app.currentLayout;

		const line = this.#winLines[id];
		if (!line) {
			return;
			// throw new Error(`Line [${id}] is not created`);
		}
		// line.tint = 0xff0000;
		slotMachine.addToGrid(line);

	}
	stop(id) {
		const line = this.#winLines[id];
		if (!line) {
			return;
			// throw new Error(`Line [${id}] is not created`);
		}
		const { slotMachine } = appDispatcher.state.app.currentLayout;

		slotMachine.removeFromGrid(line);
	}
	showAll() {
		for (const id of Object.keys(this.#winLines)) {
			this.play(id);
		}
	}
	hideAll() {
		for (const id of Object.keys(this.#winLines)) {
			this.stop(id);
		}
	}
}
